<template>
	<div>
		<a-form-model ref="addForm"  :model="theObj" :rules="rules"  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
			<a-form-model-item label="小区名称" prop="neighborName">
				<a-input  v-model="theObj.neighborName"/>
			</a-form-model-item>
			<a-form-model-item label="小区地址" prop="neighborAddr">
				<a-input  v-model="theObj.neighborAddr"/>
			</a-form-model-item>
			<a-form-model-item label="管理表">
				<a-switch default-checked   @change="changeMainMeter" checked-children="有" un-checked-children="无"/>
			</a-form-model-item>
			<a-form-model-item label="表类型">
				<a-select style="width:20rem;" v-model="theObj.type">
					<a-select-option v-for="(item,index) in neighborTypeList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="定时抄表开关">
				<a-switch   @change="changeTimerSwitch" checked-children="开" un-checked-children="关"/>
			</a-form-model-item>
			<a-form-model-item label="定时抄表时间" >
				<a-tooltip :trigger="['focus']" placement="topLeft" overlay-class-name="numeric-input">
					<span slot="title">
					      第一位为定时日期.第二位为定时小时,用短横线分割.例如:5-3,代表每月5号 凌晨3点定时抄表;6/7-4代表每月6号开始,每隔7天,凌晨4点开始抄.
					</span>
					<a-input  v-model="theObj.timer" :disabled="theObj.timerSwitch == 0"/>
				</a-tooltip>
			</a-form-model-item>
			<a-form-model-item label="抄表IP" prop="ip">
				<a-input  v-model="theObj.ip"/>
			</a-form-model-item>
			<a-form-model-item label="册本号" prop="bookNum" v-if="isWh">
				<a-input  v-model="theObj.bookNum"/>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-textarea   v-model="theObj.remark" :auto-size="{ minRows: 3, maxRows: 6 }"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			//加入这句，可以调用method里的方法
			let self = this;
			var neighborNameValidator = function(rule, value, callback){
				if(value ==null ||value == ''){
					callback(new Error('请输入小区名称'));
				}else{
					self.checkNeighborExist(value,callback);
				}
			};
			return{
				neighborTypeList:this.Config.getNeighborTypeList(),
				submitFlag:false,
				theObj:{
					neighborName:null,
					neighborAddr:null,
					mainMeter:1,
					type:0 ,
					timerSwitch:0,
					timer:null,
					ip:'114.115.215.104',
					remark:null,
				},
				rules:{
					neighborName:[
									{required:true,message:'请输入小区名称',trigger: 'blur'},
									{validator: neighborNameValidator, trigger: 'blur' },
					],
					neighborAddr:[{required:true,message:'请输入小区名称地址',trigger: 'blur'},],
					ip:[{required:true,message:'请输入监听IP',trigger: 'blur'}],
				}, 
			}
		},
		methods:{
			checkNeighborExist:function(name,callback){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_CHECK_EXIST_URL);
				let param = {neighborName:name};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					if(data.data.result ==1){
						callback(new Error('小区名称已存在'));
					}else{
						callback();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						if(this.theObj.timerSwitch == 1){
							if(this.theObj.timer == undefined && this.theObj.timer == null){
								this.$message.error('请输入定时时间');
							}else{
								this.doSubmit();
							}
						}else{
							this.doSubmit();
						}
						
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_ADD_URL);
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('添加小区成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
			changeMainMeter:function(checked,e){
				this.theObj.mainMeter = checked ? 1 : 0;
			},
			changeTimerSwitch:function(checked,e){
				if(!checked){
					this.theObj.timerSwitch = 0;
					this.theObj.timer = null;
				}else{
					this.theObj.timerSwitch = 1;
				}
			},	
		},
		computed: {
			isWh() {
				let wcId = this.Config.getUserLocal().wcId;
				if (wcId == 37){
					return true;
				}else{
					return false;
				}
			}
		},
		
	}
</script>

<style>
	.numeric-input .ant-tooltip-inner {
	  min-width: 32px;
	  min-height: 37px;
	}
</style>
